import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, CircularProgress, List, ListItem, ListItemText, IconButton, Typography, Snackbar, Paper, Box, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import backgroundImg from "../../../assets/ImgFundo/fundo-abstratoC.jpg";

const VerbeteList = () => {
  const [verbetes, setVerbetes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
  
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVerbetes = async () => {
      try {
        const response = await axios.get(`${apiUrl}/verbetes`);
        setVerbetes(response.data);
      } catch (error) {
        console.error('Erro ao buscar os verbetes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVerbetes();
  }, [apiUrl]);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    
    if (!token) {
      setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para excluir um verbete.' });
      setOpenSnackbar(true);
      return;
    }

    try {
      setAlertMessage({ type: '', text: '' });
      await axios.delete(`${apiUrl}/verbetes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAlertMessage({ type: 'success', text: 'Verbete excluído com sucesso!' });
      setVerbetes(verbetes.filter(verbete => verbete._id !== id));
    } catch (error) {
      setAlertMessage({ type: 'error', text: 'Erro ao excluir o verbete. Tente novamente.' });
    } finally {
      setOpenSnackbar(true);
    }
  };

  const handleEdit = (id) => {
    navigate(`/PainelDeControle/Editores/EditorVerbetes/${id}`);
  };

  return (
    <div
    style={{
        padding: '20px',
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        color: 'white', // Para garantir que o texto tenha boa visibilidade
    }}
>
    <Box sx={{ p: 3 }}>

<hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
        <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />

      <Typography
                   variant="h2"
                   align="center"
                   gutterBottom
                   style={{
                     fontFamily: "'Lato', serif",
                     color: "#800020",
                     textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                     borderBottom: "4px solid #d4af37",
                     paddingBottom: "10px",
                     textTransform: "uppercase",
                     animation: "glow 2s infinite alternate",
                     marginTop: "7%"  // Aqui é onde você define o espaço superior
                   }}
                 >
        Lista de Verbetes
      </Typography>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <List sx={{ backgroundColor: '#f4f6f8', borderRadius: 2, boxShadow: 1 }}>
          {verbetes.map((verbete) => (
            <Paper key={verbete._id} sx={{ marginBottom: 2, padding: 2, borderRadius: 1, boxShadow: 1 }}>
              <ListItem
                secondaryAction={
                  <>
                    <IconButton edge="end" aria-label="edit" onClick={() => handleEdit(verbete._id)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(verbete._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </>
                }
              >
                <ListItemText
                  primary={<Typography variant="h6">{verbete.titulo}</Typography>}
                  secondary={<Typography variant="body2" color="textSecondary">Autor: {verbete.autor}</Typography>}
                />
              </ListItem>
              <Divider />
            </Paper>
          ))}
        </List>
      )}
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 3 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/PainelDeControle/DashBoardVerbetes')}
          sx={{ padding: '10px 20px', fontSize: '16px' }}
        >
          Adicionar Novo Verbete
        </Button>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={alertMessage.text}
        severity={alertMessage.type}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </Box>
    </div>
  );
};

export default VerbeteList;
